// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__281Xz","buttons":"styles_buttons__2lI2H"};